"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Input_1 = require("../styled-controls/Input");
/**
 * Reusable text input component with validation error display.
 * @param {TextInputProps} props - Props for the TextInput component.
 * @returns {JSX.Element} The rendered TextInput component.
 */
const TextInput = ({ type, value, onChange, onBlur, validationError, placeholder, maxLength, id, name, }) => {
    /**
     * Handles the change event of the input field.
     * @param {React.ChangeEvent<HTMLInputElement>} e - The change event.
     */
    const handleInputChange = (e) => {
        if (onChange)
            onChange(e.target.value);
    };
    return (react_1.default.createElement(Input_1.InputContainer, null,
        react_1.default.createElement(Input_1.InputField, { type: type, value: value, onChange: handleInputChange, onBlur: onBlur, "$isError": !!validationError, placeholder: placeholder, maxLength: maxLength, id: id, name: name }),
        validationError && react_1.default.createElement(Input_1.ErrorContainer, null, validationError)));
};
exports.default = TextInput;
